import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { Region } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/region" component={Region} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Region/routes.js